import React from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { message, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';

const ForgotPasswordComponent = () => {
    const navigate = useNavigate();

    // Yup Validation Schema
    const validationSchema = Yup.object({
        email_or_phone: Yup.string()
            .required('This field is required')
            .test('is-valid', 'Must be a valid email or phone number', (value) => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const phoneRegex = /^\d{10,15}$/;
                return emailRegex.test(value) || phoneRegex.test(value);
            }),
    });

    // Submit function
    const handleSubmit = (values) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const type = emailRegex.test(values.email_or_phone) ? 'email' : 'phone';
        values.type = type;
        console.log(values);

        axios
            .post(`${process.env.REACT_APP_BACKEND_URI}/auth/forgot-password`, values)
            .then((response) => {
                message.success('Email Send Successfully');
                localStorage.setItem('verification_email', values.email_or_phone);
                navigate('/verify-otp');
            })
            .catch((error) => {
                console.log(error);
                notification.error({
                    message: 'User Does Not Exist',
                    description: 'User Does Not Exist, Please Try Again With Correct Email or Phone.',
                    placement: 'topRight',
                });
            });
    };

    return (
        <section className="account py-40 px-120">
            <div className="container container-lg">
                <Formik
                    initialValues={{
                        email_or_phone: '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ touched, errors, getFieldProps }) => (
                        <Form>
                            <div className="row gy-4">
                                <div className="col-xl-12 px-130">
                                    <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
                                        <h6 className="text-xl mb-32">Forgot Password</h6>
                                        <div className="mb-24">
                                            <label
                                                htmlFor="email_or_phone"
                                                className="text-neutral-900 text-lg mb-8 fw-medium"
                                            >
                                                Phone Number or Email Address <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`common-input ${
                                                    touched.email_or_phone && errors.email_or_phone
                                                        ? 'is-invalid'
                                                        : ''
                                                }`}
                                                id="email_or_phone"
                                                placeholder="Enter phone number or email"
                                                {...getFieldProps('email_or_phone')}
                                            />
                                            {touched.email_or_phone && errors.email_or_phone && (
                                                <div className="text-danger">
                                                    {errors.email_or_phone}
                                                </div>
                                            )}
                                        </div>
                                        <div className="mb-24 mt-48">
                                            <button type="submit" className="btn btn-main py-18 px-40">
                                                Send Reset Code
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </section>
    );
};

export default ForgotPasswordComponent;
